import dayjs from 'dayjs';
import { createSelector } from 'reselect';

import { TRootState } from '@/redux/rootReducer';
import { getFromAndTo } from '@/redux/selectors/queryParams';

import { getIsUnavailable, getUnavailableDates } from './availability';
import { getPricingInformation } from './bill';
import { getListingMinimumDays } from './page';

type TListingData = TRootState['listing']['data'];

interface IGalleryFooter {
  billPrice: ReturnType<typeof getPricingInformation>;
  dateFrom?: Date;
  dateTo?: Date;
  hasInvalidDates: boolean;
  minimumDays: ReturnType<typeof getListingMinimumDays>;
  title?: string;
  disabledDays: ReturnType<typeof getUnavailableDates>;
}

export const getGalleryFooter = createSelector<
  TRootState,
  TListingData,
  string | undefined,
  ReturnType<typeof getFromAndTo>,
  ReturnType<typeof getPricingInformation>,
  ReturnType<typeof getListingMinimumDays>,
  ReturnType<typeof getIsUnavailable>,
  ReturnType<typeof getUnavailableDates>,
  IGalleryFooter
>(
  state => state.listing.data,
  state => state.quote.errorMessage,
  getFromAndTo,
  getPricingInformation,
  getListingMinimumDays,
  getIsUnavailable,
  getUnavailableDates,
  (
    data,
    quoteError,
    selectedDates,
    pricingInformation,
    minimumDays,
    isUnavailable,
    disabledDays,
  ) => {
    const from = selectedDates.from || pricingInformation.from;
    const dateFrom = from ? dayjs(from).toDate() : undefined;

    const to = selectedDates.to || pricingInformation.to;
    const dateTo = from ? dayjs(to).toDate() : undefined;

    return {
      title: data?.name,
      dateFrom,
      dateTo,
      minimumDays,
      hasInvalidDates: Boolean(isUnavailable || quoteError),
      billPrice: pricingInformation,
      disabledDays,
    };
  },
);
